import React from 'react';
import PropTypes from 'prop-types';

import L from 'leaflet';
import { connect, Provider } from 'react-redux';
import { Popup } from 'react-leaflet';
import ListItem from '../List/ListItem';
import MapMarker from './MapMarker';
import * as actions from '../../store/actions';
import isBadCoordinate from '../../utils/isBadCoordinate';
import getPropertyIcon from '../../utils/getPropertyIcon';

import buildingMarker from './buildingMarker.png';
import siteMarker from './siteMarker.png';

import './MapMarkers.css';

export function MapMarkerComponent({
  properties,
  hoveredProperty = {},
  addHoveredProperty,
  clearHoveredProperty,
  type,
  handleModalOpen,
  markers,
  showMarkerNumbers,
}, context) {
  // const defaultIcon = type === 'sites' ? siteMarker : buildingMarker;
  const defaultIcon = propertyType => (propertyType === 'sites' ? siteMarker : buildingMarker);

  return (
    <div>
      {properties.map((property, idx) => {
        const propertyType = type || property.propertyType;
        if (
          !property.coordinates
          || isBadCoordinate(parseFloat(property.coordinates[0]))
          || isBadCoordinate(parseFloat(property.coordinates[1]))
        ) {
          return false;
        }
        const isHovered = (property._id === hoveredProperty._id);
        // const iconUrl = getPropertyIcon(property, propertyType, defaultIcon, markers);
        const iconUrl = getPropertyIcon(property, propertyType, defaultIcon(propertyType), markers);
        const iconToDisplay = showMarkerNumbers
          ?
            (
              L.divIcon({
                className: 'icon-numbered',
                iconSize: [26, 35],
                iconAnchor: [13, 36],
                html: `<span>${idx + 1}</span><img src=${iconUrl} height="35" width="26" alt="" />`,
              })
            )
          :
          (
            L.icon(
              {
                iconUrl,
                className: isHovered ? 'marker-hovered' : '',
                iconSize: [26, 35],
                iconAnchor: [13, 36],
              },
            )
          );

        return (
          <MapMarker
            key={property._id}
            icon={iconToDisplay}
            zIndexOffset={isHovered ? 1000 : 0}
            isPopupOpen={isHovered}
            position={
            [
              parseFloat(property.coordinates[1]),
              parseFloat(property.coordinates[0]),
            ]
              }
          >
            <Popup
              onOpen={() => { addHoveredProperty(property); }}
              onClose={() => { clearHoveredProperty(); }}
            >
              <Provider store={context.store}>
                <ul
                  className="list-wrapper"
                >
                  <ListItem
                    key={property._id}
                    property={property}
                    type={propertyType}
                    // handleClick={() => {}}
                    viewDetails={false /* temporary: see https://trello.com/c/076vHpzg/212-map-viewer-buildings-and-sites-view-details */}
                    handleModalOpen={handleModalOpen}
                    marker
                  />
                </ul>
              </Provider>
            </Popup>
          </MapMarker>
        );
      })}
    </div>
  );
}

MapMarkerComponent.propTypes = {
  properties: PropTypes.arrayOf(PropTypes.object),
  hoveredProperty: PropTypes.object,
  addHoveredProperty: PropTypes.func.isRequired,
  clearHoveredProperty: PropTypes.func.isRequired,
  type: PropTypes.string,
  handleModalOpen: PropTypes.func,
  markers: PropTypes.object.isRequired,
  showMarkerNumbers: PropTypes.bool,
};

MapMarkerComponent.contextTypes = {
  store: PropTypes.object.isRequired,
};

MapMarkerComponent.defaultProps = {
  showMarkerNumbers: false,
};

/* istanbul ignore next */
function mapStateToProps({ hoveredProperty, viewer }) {
  return {
    hoveredProperty,
    markers: viewer.markers,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addHoveredProperty: property => dispatch(actions.addHoveredProperty(property)),
    clearHoveredProperty: () => dispatch(actions.clearHoveredProperty()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapMarkerComponent);



// WEBPACK FOOTER //
// ./src/components/Map/MapMarkers.js